<div class="container type-editor">
    <lib-generic-dropdown
        [source]="source"
        [config]="{
            multiple: false,
            defaultText: 'Select Type',
            itemDisplayKey: 'name'
        }"
        [(selectedItem)]="selectedType"
        (selectedItemChange)="onSelectType()"
        [isReadOnly]="isReadOnly"
    >
    </lib-generic-dropdown>
</div>
